export default __webpack_public_path__ + "media/transfer-bubble/icon-rocket-68f9ab5b.png";